module.exports = __webpack_public_path__ + "img/deepak-sigdel.7d0a0278.jpg";